import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Auto-refresh on stale cache: detect chunk loading failures
window.addEventListener('error', (event) => {
  if (event.message && (
    event.message.includes('Loading chunk') ||
    event.message.includes('Loading CSS chunk') ||
    event.message.includes('Unexpected token') ||
    event.message.includes('Failed to fetch dynamically imported')
  )) {
    const lastReload = sessionStorage.getItem('last_cache_reload');
    const now = Date.now();
    if (!lastReload || (now - parseInt(lastReload)) > 10000) {
      sessionStorage.setItem('last_cache_reload', now.toString());
      window.location.reload();
    }
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA + cache management
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').then((reg) => {
    // Check for updates periodically
    setInterval(() => reg.update(), 60000);
    reg.addEventListener('updatefound', () => {
      const newWorker = reg.installing;
      if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'activated') {
            window.location.reload();
          }
        });
      }
    });
  }).catch(() => {});
}
